import ilastning from '../assets/11 vidare/1 ilastning-small.jpg';
import ilastning_small from '../assets/11 vidare/1 ilastning-small.jpg';
import lineoffflight from '../assets/11 vidare/2 lineofflight-small.jpg';
import lineoffflight_small from '../assets/11 vidare/2 lineofflight-small.jpg';

import { Article, DocsHeader, DocsHeading, Image, Section, SectionHeader } from '../extra/Components';

import {
    faBookOpen,
} from "@fortawesome/free-solid-svg-icons";

const Vidare = ({ setSection, setArticle }) => (
    <Article name="Vidare läsning" icon={faBookOpen} id="vidare" setArticle={setArticle} setSection={setSection}>
        <DocsHeader>
            <DocsHeading note="Updaterad: 2022-07-13">Vidare läsning</DocsHeading>
            <p>Här är lite information som din instruktör eventuellt tar upp under utbildning men som är bra att
                ha koll på som licensierad hoppare.</p>
        </DocsHeader>
        <Section id="ordning" name="Uthoppsordning">
            <SectionHeader>Uthoppsordning</SectionHeader>
            <Image image={ilastning} imageSmall={ilastning_small} alt="Uppställning inför ilastning" />

            <p>Vi är många i flygplanet samtidigt. Vi hoppar ut i olika grupper som gör olika saker. För att
                kunna göra det gäller det att vi sitter i den ordning. För att sätta oss i rätt ordning
                kliver påo flygplanet i omvänd uthoppsordning. Det vill säga den som hoppar av sist går på
                först.</p>
            <p>Det finns många faktorer som typ av hopp, storlek på grupp, planerade draghöjder,
                vindhastighet och storlekar på fallskärmar. Vanligtvis använder man tumregeln störst först
                och mage före friflygning. Ordning blir då enligt nedan:</p>
            <ol>
                <li><strong>Maghoppare</strong>, de som hoppare med magen neråt. Aff, formationshoppning,
                    speed star. I storleksordning med största gruppen först.</li>
                <li><strong>Friflygare</strong>, som som flyger med huvud, fötter eller rygg neråt. I
                    storleksordning med största gruppen först.</li>
                <li><strong>Tandem</strong></li>
                <li><strong>Wingsuit</strong></li>
            </ol>
            <p>Med dessa grova drag så kan man ställa sig på rätt ställe inför ilastningen. Är man osäker
                fråga någon i närheten och de hjälper dig var du ska stå.</p>
        </Section>
        <Section id="lof" name="Line of flight">
            <SectionHeader>Line of flight</SectionHeader>
            <Image image={lineoffflight} imageSmall={lineoffflight_small} alt="Uppställning inför ilastning" />

            <p>Line of flight, jump run eller flyglinje på svenska beskriver den linje flygplanet flyger
                medan grupper av
                hoppare hoppar av. Mellan grupperna väntar man runt 8 sekunder för att skapa separation i
                frifall. På så vis undviker man att krocka med hoppare man inte vet att man är i närheten
                av. När man gör hopp där man förflyttar sig horisontellt, avsiktligt eller inte, är det
                viktigt att man har kolla på line of flight när man är i frifall. Man vill göra alla sina
                förflyttningar 90 grader mot line of flight så man inte kommer närmare de som hoppar av
                innan eller efter ens egen grupp.</p>
            <p>Varför bryr man sig.</p>
        </Section>
        <Section id="jesper" name="Jesper-kurvan">
            <SectionHeader>Jesper-kurvan</SectionHeader>
            <p>I Sverige finns det många regler. När man hoppar fallskärm och har färre än 1000
                fallskärmshopp är det reglerat vad för storlek på fallskärm man får hoppa med. Försöker man
                hoppa med en mindre fallskärm ökar skaderisken om man gör misstag och blir man påkommen kan
                man bli hoppstoppad. Jesper kurvan är en tabell som beskriver relationen mellan antal hopp
                och storlek på fallskärm man får ha. Det finns en minsta tillåten och rekommenderad minsta.
                Det är inget måste att hålla sig på gränsen och byta fallskärm hela tiden. Man fortsätter i
                sitt eget tempo men kommer ihåg att när man funderar på att byta eller köpa ny fallskärm så
                finns det begränsningar av goda anledningar.
            </p>
            <p>Jesper-kurvan finns i SBF-en i kapitel 402:18.</p>
        </Section>
        <Section id="uppehall" name="Hoppning efter uppehåll">
            <SectionHeader>Hoppning efter uppehåll</SectionHeader>
            <p>Att kunna hoppa fallskärm är en färskvara som behöver repeteras med jämna mellanrum. Gör man
                uppehåll från sin hoppning ställs det olika krav innan man kan räknas som aktuell igen.
            </p>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th className="col w-auto">Licens/Tid</th>
                        <th scope="col" className="w-auto">2-6 mån</th>
                        <th scope="col" className="w-auto">6-12 mån</th>
                        <th scope="col" className="w-auto">1-2 år</th>
                        <th scope="col" className="w-auto">2-3 år</th>
                        <th scope="col" className="w-auto">3-5 år</th>
                        <th scope="col" className="w-auto">&gt;5 år</th>
                        {/** <!-- <th scope="col" className="w-50">Befogenheter</th>--> **/}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>AFF-elev</th>
                        <td>

                            Senaste nivå

                        </td>
                        <td>
                            Nivå 1 eller 2
                            Senaste hopp
                        </td>
                        <td>Hel utbildning</td>
                        <td>Hel utbildning</td>
                        <td>Hel utbildning</td>
                        <td>Hel utbildning</td>
                    </tr>
                    <tr>
                        <th>A-licens</th>
                        <td>
                            1 repetitionshopp
                        </td>
                        <td>
                            <ul>
                                <li>Teorirepetition</li>
                                <li>2 repetitionshopp</li>
                                <li>10 landningar inom 15 m</li>
                                <li>5 ensamhopp</li>
                            </ul>
                        </td>
                        <td>
                            <ul>
                                <li>Teorirepetition</li>
                                <li>2 repetitionshopp</li>
                                <li>10 landningar inom 15 m</li>
                                <li>5 ensamhopp</li>
                            </ul>
                        </td>
                        <td>
                            1-50 Hopp:<br />
                            Hel utbildning<br />
                            &gt;50 hopp:<br />
                            Teorirepetition 2
                            repetitionshopp
                            5 ensamhopp
                        </td>
                        <td>51-200 hopp:
                            Teoriprov +
                            Hopp 7-
                            9,14,17, 24
                            Alt. AFF i
                            samråd med CI</td>
                        <td>
                            &lt;200 hopp:
                            Hel utbildning.
                            &gt;200 hopp:
                            Teorirepetition
                            2 repetitionshopp
                            5 ensamhopp
                        </td>
                    </tr>
                    <tr>
                        <th>B-D licens</th>
                        <td>
                            --
                        </td>
                        <td colSpan="5">

                            Teorirepetition och repetitionshopp anpassad efter erfarenhetsnivå och tid
                            sedan senaste fallskärmshopp
                            skall göras i samråd med CI.

                        </td>
                    </tr>
                </tbody>
            </table>
            <h3>Repetitionshopp</h3>
            <p>Ett repetitionshopp genomförs enligt nedan</p>
            <ol>
                <li>Uthopp på lägst 1500 m</li>
                <li>Simulerat drag av huvudfallskärm</li>
                <li>Simulerat reservdragsförfarande</li>
                <li>Utlösning av huvudfallskärm på lägst 1000 m</li>
                <li>Hantering av eventuell kollapsbar slider</li>
                <li>Simulerad losskoppling och reservdrag</li>
                <li>Öva flärad landning med observation på stallpunkt</li>
            </ol>

        </Section>
    </Article>
);

export default Vidare;